<template>
  <div class="groupAuth_wrap">
    <div class="groupAuth_left">
      <ioc-table ref="groupTableRef" :data="groupData" :option="constData.groupTable"
        @search-change="(val) => { handleSearchChange(val, 'group'); }"
        @search-reset="(val) => { handleSearchReset('group'); }" @row-click="handleRowClick">
      </ioc-table>
    </div>
    <div class="groupAuth_right">
      <deviceListByPerson ref="deviceListByPersonRef" :personnelGroupCode="personnelGroupCode"
        @openSelectDialog="openSelectDialog">
      </deviceListByPerson>
    </div>
    <deviceSelectByPerson :selectGroup="personnelGroupCode" :showDevicePanel="showDevicePanel"
      @handleCloseDevicePanel="handleCloseDevicePanel"></deviceSelectByPerson>
  </div>
</template>

<script>
import { api } from "../api/index";
import { personTable } from "../config/personTable";
import deviceListByPerson from "./deviceListByPerson.vue";
import deviceSelectByPerson from "./deviceSelectByPerson.vue"
export default {
  name: "personAuth",
  components: {
    deviceListByPerson,
    deviceSelectByPerson
  },
  data() {
    return {
      constData: {
        groupTable: personTable(),
        groupSearchForm: {},
      },
      groupData: [],
      personnelGroupCode: '',
      showDevicePanel: false
    }
  },
  mounted() {
    this.groupGetList()
  },
  methods: {
    // 查询人员列表
    groupGetList() {
      let params = {
        ...this.constData.groupSearchForm,
      };
      this.$fetch(api.person.queryPersonList, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.groupData = res.returnObj;
        let row = { ...this.groupData[0] };
        this.$refs.groupTableRef.$refs.multipleTable.setCurrentRow(row);
        this.handleRowClick(row);
      });
    },
    // 条件搜索
    handleSearchChange(param, type) {
      this.constData[`${type}SearchForm`] = Object.assign({}, param);
      this[`${type}GetList`]();
    },
    // 条件重置
    handleSearchReset(type) {
      this.constData[`${type}SearchForm`] = {};
      this[`${type}GetList`]();
    },
    // 点击群组获取人员
    handleRowClick(row) {
      this.personnelGroupCode = row.personnelCode
      this.personnelGroupName = row.name
      this.$refs.deviceListByPersonRef.deviceGetListParent(this.personnelGroupCode, this.personnelGroupName)
    },
    // 按组添加设备
    openSelectDialog() {
      if (this.personnelGroupCode) {
        this.showDevicePanel = true;
      } else {
        this.$message({
          message: '请先选择人员',
          type: 'warning'
        });
      }
    },
    handleCloseDevicePanel() {
      this.showDevicePanel = false;
      this.$refs.deviceListByPersonRef.deviceGetList()
    }
  }
}
</script>

<style lang="scss" scoped>
.groupAuth {
  &_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  &_left {
    width: 600px;
    height: 100%;
  }

  &_right {
    width: calc(100% - 616px);
    height: 100%;
  }
}
</style>